import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import { getProjectDescription } from '../../../utils/DataUtils';

const styles = StyleSheet.create({
  section: {
    fontSize: 10,
    paddingLeft: 7,
    color: '#8c8c8c',
  },
});

export function BusinessComponentSectionDescription({ data, surveyType }) {
  const { section } = styles;
  return (
    <View style={section}>
      <Text>{getProjectDescription(data, surveyType)}</Text>
    </View>
  );
}

BusinessComponentSectionDescription.propTypes = {
  data: PropTypes.object.isRequired,
  surveyType: PropTypes.string.isRequired,
};

export default BusinessComponentSectionDescription;
